/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    textTransform: 'capitalize',
  },
}));

//  List of labels:
// 1. Buy: If all legs configured inside the algo are Buy legs, then this label will show.
// 2. Sell: If all legs configured inside the algo are Sell legs, then this label will show.
// 3. Buy / Sell: This label will show when there are sell and buy legs both configured in the algo.

const CellTransactionType = ({ row = {} }) => {
  const history = useHistory();
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '', transactionTypes = [] } = original;

  let status = '';

  if (transactionTypes.includes('B') && transactionTypes.includes('S')) {
    status = 'Buy/Sell';
  } else if (transactionTypes.includes('B')) {
    status = 'Buy';
  } else if (transactionTypes.includes('S')) {
    status = 'Sell';
  }

  const handleRedirectToAlgoEdit = () => {
    history.push(`/algos/${_id}`, {
      from: window.location.hash,
    });
  };

  return (
    <div className={classes.root} onClick={handleRedirectToAlgoEdit}>
      {status}
    </div>
  );
};

export default CellTransactionType;
